// User service for user-related API calls
import { apiClient } from './apiClient';
import {
  UserRoles,
} from '../types/userRole';
import { API_CONFIG } from '../utils/constants';

export const userRoleService = {
  /**
   * Get all user roles profile
   */
  getUserRole: async (): Promise<UserRoles[]> => {
    try {
      const response = await apiClient.get<UserRoles[]>(
        API_CONFIG.ENDPOINTS.USER_ROLES
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 2️⃣ GET SINGLE ROLE
  getRoleById: async (id: any): Promise<any> => {
    try {
      const response = await apiClient.get<any>(
        `${API_CONFIG.ENDPOINTS.USER_ROLES}/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 3️⃣ CREATE ROLE
  createRole: async (
    payload: any
  ): Promise<any> => {
    try {
      const response = await apiClient.post<any>(
        API_CONFIG.ENDPOINTS.USER_ROLES,
        payload
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 4️⃣ UPDATE ROLE (name + description only)
  updateRole: async (
    id: number,
    payload: any
  ): Promise<any> => {
    try {
      const response = await apiClient.put<any>(
        `${API_CONFIG.ENDPOINTS.USER_ROLES}/${id}`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // 6️⃣ ACTIVE ROLE COUNT
  getActiveRoleCount: async (): Promise<any> => {
    try {
      const response = await apiClient.get<{ count: any }>(
        `${API_CONFIG.ENDPOINTS.USER_ROLES}/count/active`
      );
      return response.data.count;
    } catch (error) {
      throw error;
    }
  },

  // 7️⃣ INACTIVE ROLE COUNT
  getInActiveRoleCount: async (): Promise<any> => {
    try {
      const response = await apiClient.get<{ count: any }>(
        `${API_CONFIG.ENDPOINTS.USER_ROLES}/count/Inactive`
      );
      return response.data.count;
    } catch (error) {
      throw error;
    }
  }
};

export default userRoleService;
